import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHourglassProgressComponent } from "./med-icon-hourglass-progress.component";

@NgModule({
  declarations: [
    MedIconHourglassProgressComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHourglassProgressComponent,
  ],
})
export class MedIconHourglassProgressModule { }
